module.exports = "https://cdn.zapier.com/blog/9bdf6c1b0e1defd015c6304f538aae479177ea11/_next/static/images/green-09739247ae782ed1306737140440699c.png";